import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../admin_resources/css/admin_layout.css";
import "../../../admin_resources/css/admin_common.css";
import "../../../admin_resources/css/admin_style.css";
import ADMIN_HEADER from "../Admin_Header";
import ADMIN_FOOTER from "../Admin_Footer";
import axios from "axios";
import xlsx from "../../../resources/images/common/excel_icon.png";

const Admin_Franchise = () => {
  const navigate = useNavigate();
  const [frenchise, setFrenchise] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 관리자 페이지`;

    // 처음 데이터 로딩
    const fetchPresenList = async () => {
      try {
        // API 호출하여 데이터 받아오기
        const response = await axios.get("/franchise");

        const sortedApply = response.data.sort((a, b) => {
          return new Date(a.fridx) - new Date(b.fridx);
        });

        setFrenchise(sortedApply);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching franchise:", error);
      }
    };

    fetchPresenList();

	  // 관리자 권한 정보 가져오기
	  const adminId = localStorage.getItem("adminId");
	  if (adminId) {
	    fetchPermissions(adminId);
	  }
	}, []);

	const fetchPermissions = async (adminId) => {
	  try {
	    const response = await fetch(`/permissions/${adminId}`); // 권한 확인 API 호출
	    const data = await response.json();
	    setPermissions(data); // 권한 정보를 상태로 설정
	  } catch (error) {
	    console.error("권한 정보를 가져오는 데 실패했습니다.", error);
	  }
	};

  // 페이지네이션 처리
  const indexOfLastApply = currentPage * itemsPerPage;
  const indexOfFirstApply = indexOfLastApply - itemsPerPage;
  const currentApply = frenchise.slice(indexOfFirstApply, indexOfLastApply);
  const totalPages = Math.ceil(frenchise.length / itemsPerPage);

  // 페이지 범위 설정
  const pageRange = 10; // 최대 페이지 번호 개수
  const startPage = Math.floor((currentPage - 1) / pageRange) * pageRange + 1;
  const endPage = Math.min(startPage + pageRange - 1, totalPages);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const downloadExcel = async () => {
    try {
      const response = await axios.get("/exceldownload", {
        responseType: "blob", // 중요한 부분: blob 형식으로 받아야 함
      });

      // 파일 이름 가져오기 (Content-Disposition 헤더에서 추출)
      const disposition = response.headers["content-disposition"];
      const fileName = disposition
        ? decodeURIComponent(
            disposition.split("filename=")[1].replace(/"/g, "")
          )
        : "FranchiseData.xls";

      // Blob 생성
      const blob = new Blob([response.data], {
        type: "application/vnd.ms-excel",
      });

      // 다운로드 링크 생성 및 클릭
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName; // 백엔드에서 받아온 파일 이름 사용
      link.click();
    } catch (error) {
      console.error("Excel 파일 다운로드 실패:", error);
    }
  };

  return (
    <div>
      <ADMIN_HEADER />
      <div className="main_compo">
        <div className="path-sec">
          HOME &gt; <span className="menu1">데이터 관리</span> &gt;
          <span className="menu2"> 창업 일정 관리</span>
        </div>
        <table>
          <tr>
            <td>
              <div className="sec-snb">
                <h3 className="snb_tit">데이터 관리</h3>
                <ul className="snb_list">
				{permissions.ent && (
				  <li>
				    <a href="/admin/form/ent">입회신청 관리</a>
				  </li>
				)}
				{permissions.fr && (
				  <li>
				    <a href="/admin/form/fr">창업신청 관리</a>
				  </li>
				)}
				{permissions.franchise && (
				  <li className="cur">
				    <a href="/admin/form/franchise">가맹점 관리</a>
				  </li>
				)}
				{permissions.schedule && (
				  <li>
				    <a href="/admin/form/schedule">창업일정 관리</a>
				  </li>
				)}
				{permissions.jisa && (
				  <li>
				    <a href="/admin/form/jisa">지사장 지원 관리</a>
				  </li>
				)}
				{permissions.q && (
				  <li>
				    <a href="/admin/form/q">앱 문의 관리</a>
				  </li>
				)}
				{permissions.etc_q && (
				  <li>
				    <a href="/admin/form/etc_q">기타문의 관리</a>
				  </li>
				)}
                  {(localStorage.getItem("adminId") === "jiwoo" ||
                    localStorage.getItem("adminId") === "nixona" ||
                    localStorage.getItem("adminId") === "wjdrnr90" ||
                    localStorage.getItem("adminId") === "hyoseon.jang") && (
                    <li>
                      <a href="/admin/form/point">적립금 정산 관리</a>
                    </li>
                  )}
                </ul>
              </div>
            </td>
            <td className="right_m">
              <div className="sec-cont">
                <form name="delfrm">
                  <input type="hidden" name="mode" value="chk_del" />
                  <div className="tb_01">
                    <div className="bx_sch_btm bg_1">
                      현재 가맹점 수 : {frenchise.length} 개&nbsp;&nbsp;
                      <button onClick={downloadExcel}>
                        <img src={xlsx} width="25px" height="25px" alt="xlsx" />
                      </button>
                      &nbsp;&nbsp;
                      <span className="btn info">
                        <button
						onClick={(e) => {
						  e.preventDefault(); // 새로고침 방지
						  downloadExcel();
						}}
                          style={{
                            backgroundColor: "#2196f3",
                            color: "#fff",
                            fontWeight: "bold",
                          }}
                        >
                          다운로드
                        </button>
                      </span>
                    </div>
                    <table>
                      <thead>
                        <tr>
                          <th>번호</th>
                          <th>교육원명</th>
                          <th>지역</th>
                          <th>시/군/구</th>
                          <th>동/읍/면</th>
                          <th>전화번호</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentApply.length > 0 ? (
                          currentApply.map((applys, index) => (
                            <tr key={applys.fridx}>
                              <td>
                                {frenchise.length - indexOfFirstApply - index}
                              </td>
                              <td>{applys.frTitle}</td>
                              <td>{applys.frArea1}</td>
                              <td>{applys.frArea2}</td>
                              <td>{applys.frArea3}</td>
                              <td>{applys.frTel}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" style={{ textAlign: "center" }}>
                              등록된 내용이 없습니다.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </form>
              </div>
              <div className="sec-btn-apply">
                <div className="dataTables_paginate">
                  <button
                    className="paginate_button previous"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    이전
                  </button>
                  {Array.from(
                    { length: endPage - startPage + 1 },
                    (_, index) => (
                      <button
                        key={startPage + index}
                        className={`paginate_button ${
                          currentPage === startPage + index ? "active" : ""
                        }`}
                        onClick={() => handlePageChange(startPage + index)}
                      >
                        {startPage + index}
                      </button>
                    )
                  )}
                  {endPage <= totalPages && (
                    <button
                      className="paginate_button next"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      다음
                    </button>
                  )}
                </div>
                <span className="btn custom_r" style={{ marginRight: "20px" }}>
                  <button
                    onClick={() => navigate("/admin/form/franchise_write")}
                  >
                    등록
                  </button>
                </span>
              </div>
            </td>
          </tr>
        </table>
      </div>
	  <ADMIN_FOOTER/>
    </div>
  );
};

export default Admin_Franchise;
